/**
 * @file
 * Media queries helper
 *
 * @module mq
 */

var grid = {
  S : 319,
  M : 1023,
  L : 1439,
};

module.exports = {
  isSmallerThan: function(letter) {
    return window.innerWidth < grid[letter];
  },
  isBiggerThan: function(letter) {
    return window.innerWidth > grid[letter];
  },
};



// WEBPACK FOOTER //
// ./src/js/helpers/mq.js